import { http } from "../base";
import ossClient from '@/util/private-oss';
export function listAllDirectories(kbWorkspaceSlug) {
    return http.get(
         '/aics/kb_doc/list_all_dirs/'+kbWorkspaceSlug
    )
}

// 获取目录列表（返回目录名称数组）
export async function listAllDirs(kbWorkspaceSlug) {
  console.log("listAllDirs", kbWorkspaceSlug);
  const response = await http.get(
    `/aics/kb_doc/list_all_dirs/${kbWorkspaceSlug}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log(response);
  // 统一处理响应格式
  if (response == null || response.status !== 200) {
    throw new Error(response?.data?.message || '获取目录列表失败');
  }
  return response.data;
}

export async function getDefaultFolder(tenantId) {
  const response = await http.get(
    `/aics/kb_doc/get_default_folder/${tenantId}`,    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
    console.log(response);
    // 统一处理响应格式
    if (response==null || response.status !== 200) {
      throw new Error(response.data.message || '获取文档列表失败');
    }
    return response.data;
  }
export async function listDocuments_by_WorkspaceSlug(kb_workspace_slug) {

  console.log("listDocuments_by_WorkspaceSlug",kb_workspace_slug);
  const response = await http.get(
    `/aics/kb_doc/list_all_dirs/${kb_workspace_slug}`,    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
    console.log(response);
    // 统一处理响应格式
    if (response==null || response.status !== 200) {
      throw new Error(response.data.message || '获取文档列表失败');
    }
    return response.data;
  }

  export async function listDocuments_in_folder(kb_workspace_slug, params) {
  console.log("listDocuments_in_folder", kb_workspace_slug, params);
  
  const { pageNum, pageSize,docType, dirId, keyword } = params;
  let dir_id =0;
  console.log(dirId, docType);
  if(dirId !== '' && dirId!==null && dirId !==undefined)
      dir_id = dirId;
    console.log("listDocuments_in_folder",
        `/aics/kb_doc/list_documents_in_folder/${kb_workspace_slug}?doc_type=${docType}&dir_d=${dir_id}&keyword=${keyword}&pageNum=${pageNum}&pageSize=${pageSize}`
    )
  const response = await http.get(
    `/aics/kb_doc/list_documents_in_folder/${kb_workspace_slug}?doc_type=${docType}&dir_id=${dir_id}&keyword=${keyword}&pageNum=${pageNum}&pageSize=${pageSize}`, {

      headers: { 'Content-Type': 'application/json' }
    }
  );
  
  console.log(response);
  if (response == null || response.status !== 200) {
    throw new Error(response.message || '获取文档列表失败');
  }
  return response.data;
}

    export async function query_document_details(doc_id) {
      console.log("query_document_details",doc_id);
      const response = await http.get(
        `/aics/kb_doc/${doc_id}`,    {
          headers: { 'Content-Type': 'application/json' }
        }
      );
        console.log(response);
        // 统一处理响应格式
        if (response==null || response.status !== 200) {
          throw new Error(response.message || '获取文档详情失败');
        }
        return response.data;
      }

          export async function query_richdoc_details(doc_id) {
      console.log("query_richdoc_details",doc_id);
      const response = await http.get(
        `/aics/kb_doc/rich_doc/${doc_id}`,    {
          headers: { 'Content-Type': 'application/json' }
        }
      );
        console.log(response);
        // 统一处理响应格式
        if (response==null || response.status !== 200) {
          throw new Error(response.message || '获取文档详情失败');
        }
        return response.data;
      }

    export async function getDocumentStatic_by_tenant(tenantId) {

      console.log("getDocumentStatic_by_tenant",tenantId);
      const response = await http.get(
        `/aics/kb_doc/static_by_tenant?tenantId=${tenantId}&userName=`,    {
          headers: { 'Content-Type': 'application/json' }
        }
      );
        console.log(response);
        // 统一处理响应格式
        if (response==null || response.status !== 200) {
          throw new Error(response.message || '获取文档列表失败');
        }
        return response.data;
      }

      // 新增 OSS 上传接口
      
      export async function uploadToOSS(file, tenant_id, folder) {
        try {
          console.log("uploadToOSS", file, tenant_id, folder)
          const result = await ossClient.uploadFile(file, folder, tenant_id);

          if (result.success) {
            return {
              code: 200,
              message: '上传成功',
              data: result
            };
          } else {
            throw new Error(`OSS上传失败: ${result.error}`);
          }
        } catch (error) {
          throw {
            code: 500,
            message: `上传异常: ${error.message}`
          };
        }
      }

  // 新增触发 AnythingLLM 处理的接口
  export function triggerAnythingLLMProcess(ossData, workspace, targetFolder, tenant_id, user_name, dir_id, file_size) {
    console.log('triggerAnythingLLMProcess', ossData, workspace, targetFolder, tenant_id, user_name, dir_id, file_size)
    console.log('ossData.fileName', ossData.fileName)
    return http.post('/api/files/trigger-upload',
       {
        ossObjectKey: ossData.objectKey,
        targetWorkspaceSlug: workspace,
        targetFolder: targetFolder,
        originalFilename: ossData.fileName,
        contentType: 'application/octet-stream',
        tenantId: tenant_id,
        dirId: dir_id,
        fileSize: file_size,
        userName: user_name
      });
    }


    export async function addFolder(tenantId, name) {
      console.log("addFolder",tenantId, name);
      const response = await http.post(
        `/aics/kb_doc/add_folder?tenantId=${tenantId}&name=${name}`,
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );
      return response;
    }

    export async function updateFolder(id, tenantId, name) {
      console.log("updateFolder",tenantId, name);
      const response = await http.post(
        `/aics/kb_doc/update_folder?dirId=${id}&tenantId=${tenantId}&name=${name}`,
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );
      return response;
    }
    export async function deleteFolder(id) {
      console.log("updateFolder",id);
      const response = await http.delete(
        `/aics/kb_doc/delete_folder/`+id,
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );
      return response;
    }

  export async function checkDefaultFolder(tenantId) {
    console.log("checkDefaultFolder",tenantId);
    const response = await http.post(
      `/aics/kb_doc/check_default_folder?tenantId=${tenantId}`,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    console.log(response)
    return response;
}

export async function listBriefDirsByTenantid(tenantId) {
  console.log("listDirbriefsByTenantid",tenantId);
  const response = await http.get(
    `/aics/kb_dir/list_briefdirs_by_tenantid/${tenantId}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
}

export async function listDirsByTenantid(tenantId) {
  console.log("listDirsByTenantid",tenantId);
  const response = await http.get(
    `/aics/kb_dir/list_dirs_by_tenantid/${tenantId}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
}


export async function is_document_exist_in_folder(docName, folderName, tenantId) {
  console.log('is_document_exist_in_folder', docName, folderName)
  const response = await http.get(
    `/aics/kb_doc/is_document_exist_in_folder?folder_name=${folderName}&doc_name=${docName}&tenant_id=${tenantId}`,
  );
  return response;
}

/**
 * 删除文档
 * @param {number|string} id - 文档ID
 * @returns {Promise<Object>} 返回后端响应的数据对象
 */
export async function deleteDocument(id) {
  console.log("deleteDocument called with id:", id);
  
  try {
    const response = await http.delete(`/aics/kb_doc/` + id, {
      headers: { 'Content-Type': 'application/json' }
    });
    
    console.log("deleteDocument response:", response);
    
    // 直接返回 response.data（后端返回的数据）
    // 后端返回格式: {code: 200, message: '操作成功', timestamp: ...}
    return response.data;
    
  } catch (error) {
    console.error("deleteDocument error:", error);
    // 重新抛出错误，让调用方处理
    throw error;
  }
}

export async function get_temp_url(data) {
  console.log("get_temp_url", data);
  const response = await http.post(
    `/aics/kb_doc/get_download_url`,
    data,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;  
}

export async function is_url_existed_in_dir(url, dirId) {
  console.log('is_url_existed_in_dir', url, dirId)
    // 对URL参数进行编码
  const encodedUrl = encodeURIComponent(url);
    const response = await http.get(
      `/aics/kb_doc/is-url-existed-in-dir?url=${encodedUrl}&dir_id=${dirId}`,
  );
  return response;
}

export async function uploadLink(data) {
  console.log('uploadLink', data)
    const response = await http.post(      
      '/aics/kb_doc/upload-link',
    data,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
} 

export async function createOrUpdateQADocument(params){
  console.log("createOrUpdateQADocument", params)
    const response = await http.post(      
      '/aics/kb_doc/qa',
    params,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
}